import { useGetAppDetails } from "../../services";

export const AppDetailsWrapper = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  useGetAppDetails();

  return children;
};
